import React from 'react';
import { Link } from 'react-router-dom';

type V2AdminPageHeadingProps = {
  title: string;
  description?: string;
  action?: React.ReactNode;
  backLink?: {
    to: string;
    label: string;
  };
};

const V2AdminPageHeading: React.FC<V2AdminPageHeadingProps> = ({
  title,
  description,
  action,
  backLink,
}) => (
  <section className="player-heading v2-admin-page-heading">
    <div>
      {backLink ? (
        <Link className="v2-admin-back-link" to={backLink.to}>
          {backLink.label}
        </Link>
      ) : null}
      <div className="player-title-line">
        <h1>{title}</h1>
      </div>
      {description ? <p className="profile-description">{description}</p> : null}
    </div>
    {action ? <div className="v2-admin-page-heading__actions">{action}</div> : null}
  </section>
);

export default V2AdminPageHeading;
